
const scenarioIds = [
	'game1', 'game2', 'game3', 'game4', 'game5'
];

const scenariosData = {
	game1: {
		id: 'game1',
		title: 'HTX',
		url: 'htx',
		gameUrl: 'HTXSPIL.DK',
		gameDurationMinutes: 40,
		defaultQrUrl: 'da.surveymonkey.com/r/HTXTechGame',
		gamePagesData: require('data/game1/game-pages-data').gamePagesData,
		tasksData: {
			build: require('data/game1/assignments/build-tasks-data').tasksData,
			safety: require('data/game1/assignments/safety-tasks').tasksData,
			education: require('data/game1/assignments/education-tasks-data').tasksData,
			it: require('data/game1/assignments/it-tasks-data').tasksData,
			research: require('data/game1/assignments/research-tasks-data').tasksData
		}
	},
	game2: {
		id: 'game2',
		title: 'HHX',
		url: 'hhx',
		gameUrl: 'HHXSPIL.DK',
		gameDurationMinutes: 40,
		defaultQrUrl: 'da.surveymonkey.com/r/BusinessGameDK',
		gamePagesData: require('data/game2/game-pages-data').gamePagesData,
		tasksData: {
			sales: require('data/game2/assignments/sales-tasks-data').tasksData,
			it: require('data/game2/assignments/it-tasks-data').tasksData,
			economy: require('data/game2/assignments/economy-tasks-data').tasksData,
			investment: require('data/game2/assignments/investment-tasks-data').tasksData,
			education: require('data/game2/assignments/education-tasks-data').tasksData
		}
	},
	game3: {
		id: 'game3',
		title: 'STX',
		url: 'stx',
		gameUrl: 'STXSPIL.DK',
		gameDurationMinutes: 35,
		defaultQrUrl: 'da.surveymonkey.com/r/STXGame', // TODO
		gamePagesData: require('data/game3/game-pages-data').gamePagesData,
		tasksData: {
			fields: require('data/game3/assignments/fields-tasks-data').tasksData,
			logic: require('data/game3/assignments/logic-tasks-data').tasksData,
			education: require('data/game3/assignments/education-tasks-data').tasksData,
			social: require('data/game3/assignments/social-tasks-data').tasksData,
			teaching: require('data/game3/assignments/teaching-tasks-data').tasksData
		}
	},
	game4: {
		id: 'game4',
		title: 'HF',
		url: 'hf',
		gameUrl: 'HFSPIL.DK',
		gameDurationMinutes: 35,
		defaultQrUrl: 'da.surveymonkey.com/r/HFGAME', // TODO
		gamePagesData: require('data/game4/game-pages-data').gamePagesData,
		tasksData: {
			subjectsHf: require('data/game4/assignments/subjects-hf-tasks-data').tasksData,
			logic: require('data/game4/assignments/logic-tasks-data').tasksData,
			education: require('data/game4/assignments/education-tasks-data').tasksData,
			social: require('data/game4/assignments/social-tasks-data').tasksData,
			teaching: require('data/game4/assignments/teaching-tasks-data').tasksData
		}
	},
	game5: {
		id: 'game5',
		title: 'EUD/EUX Business',
		url: 'eudeux',
		gameUrl: 'EUDEUX.DK',
		gameDurationMinutes: 40,
		defaultQrUrl: 'da.surveymonkey.com/r/BusinessGameDK',
		gamePagesData: require('data/game5/game-pages-data').gamePagesData,
		tasksData: {
			sales: require('data/game5/assignments/sales-tasks-data').tasksData,
			marketing: require('data/game5/assignments/marketing-tasks-data').tasksData,
			it: require('data/game5/assignments/it-tasks-data').tasksData,
			management: require('data/game5/assignments/management-tasks-data').tasksData,
			economy: require('data/game5/assignments/economy-tasks-data').tasksData,
		}
	}
};

export {
	scenarioIds,
	scenariosData
};